// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfills'
import 'es6-promise/auto'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import { sync } from 'vuex-router-sync'
import auth from './services/auth'
import './filters'
sync(store, router)

Vue.use(VueResource)

router.beforeEach((to, from, next) => {
  if (to.fullPath.indexOf('admin') >= 0 && to.name !== 'Login' && !store.state.auth.token) {
    next('/admin')
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

if (auth.checkLocalToken()) {
  store.commit('auth/LOGIN', auth.token)
}

const eventBus = new Vue()
Vue.prototype.$eventBus = eventBus

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js